import _ from "lodash";
import React, { useEffect } from "react";
import { useContext } from "react";
import Context from "../store/context/ContextProvider";
import { getData } from "../store/context/Actions";
import Table from "../base/tables/Sortabe";

const employeeData = [
  {
    Name: ["John", "Amit"],
    Title: ["Software Engineer","QA"],
    Company: ["IBM","ABC Inc."],
    "Quick Actions": "Edit",
    "Contact Location": "New York",
    "#employees": 100,
    Email: ["john@example.com", "gyyy@test.com"],
    Industry: ["IT","Retail"],
    Keywords: ["React", "Node.js"],
  },
  // Add more data objects as needed...
];

const columns = [
  "Name",
  "Title",
  "Company",
  "Quick Actions",
  "Contact Location",
  "#Employees",
  "Email",
  "Industry",
  "Keywords",
];

const Main = () => {
  const { data, dispatch } = useContext(Context);
  const statsTimeline = _.get(data, "data.statsTimeline");
  const profile_info = _.get(data, "data.Profile Info");

  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const fetchData = async () => {
      const res = await getData();
      dispatch({ type: "GET_DATA", payload: res });
    };
    fetchData();
  }, [dispatch]);
  return (
    <>
      <Table data={employeeData} columns={columns} />
    </>
  );
};

export default Main;
